import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import round from 'lodash/round';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import types from '../../../../../types';
import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const percentOptions = range(0, 1.05, 0.05).map(value => ({
  value: round(value, 2),
  display: `${round(value * 100)}%`,
}));

const InstallWaterEfficientLandscaping = ({
  t,
  isMetric,
  inputFootprintHousingSquarefeet,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line no-template-curly-in-string
            __html: t('A household of {{homeArea}} {{homeAreaUnits}} typically has', {
              homeArea: inputFootprintHousingSquarefeet.ensuredDisplay,
              homeAreaUnits: `${t((isMetric ? 'm' : 'ft'), { ns: 'units' })}<sup>2</sup>`,
            }),
          }}
        />
        <InlineInput
          maxLength={5}
          apiKey={'input_takeaction_water_efficient_landscaping_sqft'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line no-template-curly-in-string
            __html: t('{{areaUnits}}<sup>2</sup> of landscaped area.', {
              areaUnits: isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' }),
            }),
          }}
        />
      </p>
      <p>
        {t('Water efficient landscapes can be obtained by introducing more drought-tolerant plants to your landscape and maintaining them more efficiently with drip-irrigation. ')}
      </p>
      <p><b>{t('Landscaping')}</b></p>
      <p>
        {t('The current composition of my landscape is:')}
      </p>
      <ul>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_grass_old'}
          />
          {t('grass')}
        </li>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_plants_old'}
          />
          {t('plants')}
        </li>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_drought_old'}
          />
          {t('drought-tolerant')}
        </li>
      </ul>
      <p>
        {t('I will redo my landscaping so that the new composition of my landscape is:')}
      </p>
      <ul>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_grass_new'}
          />
          {t('grass')}
        </li>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_plants_new'}
          />
          {t('plants')}
        </li>
        <li>
          <InlineSelect
            options={percentOptions}
            apiKey={'input_takeaction_water_efficient_landscaping_drought_new'}
          />
          {t('drought-tolerant')}
        </li>
      </ul>
      <h3>{t('Irrigation')}</h3>
      <p>
        {t('Currently,')}
        <InlineSelect
          options={percentOptions}
          apiKey={'input_takeaction_water_efficient_landscaping_grass_drip_old'}
        />
        {t('of my grass and')}
        <InlineSelect
          options={percentOptions}
          apiKey={'input_takeaction_water_efficient_landscaping_plant_drip_old'}
        />
        {t('of my plants are maintained through drip-irrigation.')}
      </p>
      <p>
        {t('I will rework my irrigation so that')}
        <InlineSelect
          options={percentOptions}
          apiKey={'input_takeaction_water_efficient_landscaping_grass_drip_new'}
        />
        {t('of my grass and')}
        <InlineSelect
          options={percentOptions}
          apiKey={'input_takeaction_water_efficient_landscaping_plant_drip_new'}
        />
        {t('of my plants are maintained through drip-irrigation.')}
      </p>
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <p>
        {t('We assume that the incremental cost of drip irrigation is')}
        <InlineInput
          currency
          maxLength={5}
          apiKey={'input_takeaction_water_efficient_landscaping_cost_drip'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('per {{areaUnits}}<sup>2</sup> and the incremental cost of drought-tolerant plants is', {
              areaUnits: isMetric ? t('m') : t('ft'),
            }),
          }}
        />
        <InlineInput
          currency
          maxLength={5}
          apiKey={'input_takeaction_water_efficient_landscaping_cost_drought'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('per {{areaUnits}}<sup>2</sup>.', {
              areaUnits: isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' }),
            }),
          }}
        />
      </p>
    </div>
  </div>
);

InstallWaterEfficientLandscaping.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  inputFootprintHousingSquarefeet: types.UserInput.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'inputFootprintHousingSquarefeet',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('waterEfficientLandscaping'),
  connect(mapStateToProps, mapDispatchToProps)(InstallWaterEfficientLandscaping),
);
